<template>
  <div class="flex-row d-flex font-size">
    <v-icon small @click="decrease()" color="black">mdi-minus</v-icon>
    <div class="size">{{ size }}</div>
    <v-icon small @click="increase()" color="black">mdi-plus</v-icon>
  </div>
</template>

<script>

export default {
  name: 'FontSize',
  props: {
    styles: {},
    defaultSize: {
      type: Number,
      default: 12
    }
  },
  computed: {},
  watch: {
    size () {
      this.$emit('update:styles', { fontSize: this.size + 'px' })
    }
  },
  data () {
    return {
      size: 12
    }
  },
  created () {
    if (this.styles && this.styles.fontSize) {
      this.size = this.styles.fontSize.split('px')[0]
    } else {
      this.size = this.defaultSize
    }
  },
  methods: {
    increase () {
      if (this.size <= 48) {
        this.size++
      }
    },

    decrease () {
      if (this.size >= 5) {
        this.size--
      }
    },

    reset () {
      this.size = this.defaultSize
    }
  }
}

</script>

<style lang="sass" scoped>

.font-size
  border: 1px solid rgba(0, 0, 0, 0.12)
  .size
    padding: 0px 5px
    border-left: 1px solid rgba(0, 0, 0, 0.12)
    border-right: 1px solid rgba(0, 0, 0, 0.12)

</style>
